import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/news.png'


const _hoisted_1 = { class: "news-detail" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "news-detail-img"
  })
], -1)
const _hoisted_3 = { class: "news-detail-title" }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, { titleId: 5 }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.newDetail.name), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.newDetail.created_at), 1)
      ]),
      _createElementVNode("div", {
        class: "news-detail-content",
        innerHTML: _ctx.newDetail.content
      }, null, 8, _hoisted_4)
    ]),
    _createVNode(_component_Bottom)
  ]))
}